import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Heart } from 'lucide-react';
import styles from './Components/CSS/CategoryBlog.module.css';
import { useCategoryBlogs } from '../hooks/useBlogs';
import Loading from '../common/HousGlass Loader/Loading';

const CategoryBlogs = () => {
  const navigate = useNavigate();
  const { name } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const { blogs, pagination, isLoading, error } = useCategoryBlogs(name, currentPage);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingText}><Loading/></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorText}>
          Error: {error.response?.data?.message || 'Failed to fetch blogs'}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <header className={styles.hero}>
        <h1 className={styles.heroTitle}>{name}</h1>
      </header>

      <main className={styles.blogGrid}>
        {blogs.map((blog) => (
          <article key={blog.id} className={styles.blogCard}>
            <div className={styles.imageWrapper}>
              <img
                src={blog.featuredImage || "/images/HeroImage.png"}
                alt={blog.title}
                className={styles.cardImage}
              />
              <span className={styles.category}>{blog.category}</span>
            </div>

            <div className={styles.cardContent}>
              <div className={styles.authorInfo}>
                <div className={styles.author}>
                  <div className={styles.avatarCircle}>
                    {blog.author?.name?.[0] || 'A'}
                  </div>
                  <span className={styles.authorName}>{blog.author?.name || 'Anonymous'}</span>
                </div>
                <time className={styles.date}>
                  {new Date(blog.publishedAt).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </time>
              </div>

              <h2 className={styles.cardTitle}>{blog.title}</h2>
              <p className={styles.cardDescription}>
                {blog.content.replace(/<[^>]*>/g, '').substring(0, 150)}...
              </p>

              {/* ✅ Navigate to the blog detail page on click */}
              <span
                className={styles.learnMore}
                onClick={() => navigate(`/blog/${blog.slug}`)}
              >
                Learn More
              </span>
            </div>
          </article>
        ))}
      </main>

      {pagination && pagination.pages > 1 && (
        <div className={styles.pagination}>
          <button
            className={styles.pageButton}
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => prev - 1)}
          >
            Previous
          </button>
          <span className={styles.pageInfo}>
            Page {currentPage} of {pagination.pages}
          </span>
          <button
            className={styles.pageButton}
            disabled={currentPage === pagination.pages}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryBlogs;
